import React from 'react';
import { FaWpforms } from 'react-icons/fa';
import { BiLinkExternal } from 'react-icons/bi';
import { BootstrapToolTip } from '../../../../../../_elements/ToolTip';
import { ActionStyles } from '../../../../../Admin/reusableStyles';
import { ViewUserForm } from '../../../../../Admin/Form/SubmittedForm';
import { toAbsoluteUrl } from './CertificateExpiryBadge';

const CertificateActionButtons = ({ formId, courseRenewalLink }) => {
    return (
        <div className="d-flex align-items-center justify-content-center gap-1">
            {formId && (
                <BootstrapToolTip text="Certificate Form Submission">
                    <ViewUserForm id={formId}>
                        <ActionStyles className="view-icon">
                            <FaWpforms className="icon" />
                        </ActionStyles>
                    </ViewUserForm>
                </BootstrapToolTip>
            )}
            {courseRenewalLink && (
                <BootstrapToolTip text="Renew Certificate">
                    <a href={toAbsoluteUrl(courseRenewalLink)} target="_blank" rel="noopener noreferrer">
                        <ActionStyles>
                            <BiLinkExternal className="icon edit" />
                        </ActionStyles>
                    </a>
                </BootstrapToolTip>
            )}
        </div>
    );
};

export { CertificateActionButtons };
export default CertificateActionButtons;
